import React, { ReactElement, useMemo, useState } from "react";
import { FunctionComponent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAdboxDailyMetrics } from "../../actions/monetization";
import Spinner from "../../components/Spinner";
import { WorkState } from "../../reducers/models";
import { getDailyMetrics } from "../../selectors/monetizationSelector";
import styles from "../../styles/admanager/UserEarningsReport.module.scss"
import styles_TabOptions from "../../styles/TabOptions.module.scss"
import { METRICS_BY_DAY_TOTALS_COLUMNS, METRICS_BY_DAY_ITEMS_COLUMNS } from "../../textContent/tableColumns";
import GenericTable from "../helpers/genericTable";

type DailyMetrics = bb.model.monetization.IAdboxDailyMetrics

interface UserMetricByDayProps {

}

function renderTables(props:any):ReactElement|undefined {
  const data = props.data as DailyMetrics
  const {totalColumns, itemsColumns, rowClickCallback, tablePaginationProps} = props
  if (data===undefined || data.workState===WorkState.None || data.workState===WorkState.Error) {
    return undefined
  }
  else if (data.workState===WorkState.Loading) {
    return (
      <Spinner
        isLoading={true}
        spinnerStyle={undefined}
      />
    )
  }
  else if (data.dailyMetrics.totals.length===0) {
    return <h3 className={styles.emptyReportText}>
      No data found within the selected data range
    </h3>

  }
  return (
    <>
      <p className={styles.dailyMetricsDisclaimer}>These metrics are estimates and should not be considered as final, guaranteed, or completely accurate.</p>

      <h3 className={styles.dailyMetricsTableTitle}>Aggregated</h3>
      <GenericTable
        wrapperId={styles.dailyTotalsTableWrapper}
        data={data.dailyMetrics.totals}
        columns={totalColumns}
        rowClickCallback={rowClickCallback}
        tablePaginationProps={tablePaginationProps}
        scrollToOption={false}
      />

      <h3 className={styles.dailyMetricsTableTitle}>By Day</h3>
      <GenericTable
        wrapperId={styles.dailyItemsTableWrapper}
        data={data.dailyMetrics.items}
        columns={itemsColumns}
        rowClickCallback={rowClickCallback}
        tablePaginationProps={tablePaginationProps}
        scrollToOption={false}
      />
    </>
  )
}

const UserMetricByDay: FunctionComponent<UserMetricByDayProps> = () => {
    const dispatch = useDispatch();
    const dailyMetrics = useSelector(getDailyMetrics);
    const [buttons, setButtons] = useState([{ title: 'Last 7 Days', active: false }, { title: 'Last 30 Days', active: false }, { title: 'Month to Date', active: false }]);

    const handleClick = async (name: {title: 'Last 7 Days' | 'Last 30 Days' | 'Month to Date'}) => {
        const today = new Date();
        const endDate = new Date();
        
        const startDates = {
            'Last 7 Days': new Date(new Date().setDate(today.getDate() - 7)),
            'Last 30 Days': new Date(new Date().setDate(today.getDate() - 30)),
            'Month to Date': new Date(today.getFullYear(), today.getMonth(), 1)
        };
        
        
        setButtons(buttons.map(button => {
            button.title === name.title ? button.active = true : button.active = false;
            return button;
        }));
        await dispatch(getAdboxDailyMetrics(startDates[name.title], endDate));
    }

    const totalColumns = useMemo(
        () => [
            {
                Header: " ",
                columns: METRICS_BY_DAY_TOTALS_COLUMNS,
            },

        ],
        []
    );

    const itemsColumns = useMemo(
        () => [
            {
                Header: " ",
                columns: METRICS_BY_DAY_ITEMS_COLUMNS,
            },

        ],
        []
    );

    const data = useMemo(() => dailyMetrics, [dailyMetrics]);

    const tablePaginationProps = {
        showSkipToEnd: false,
        showSkipToBeginning: false,
        showPageSizeDropdown: false,
        showGoToPage: false,
        pageItem: 10,
        rowHeight: 51,
    };
    const rowClickCallback = (row: any) => {
        console.log("rowClickCallback", row);
    };

    return (
        <div className={styles.reportControlsContainer}>
            <h6 className={styles.betaWarning}>This section of the dashboard is in <span>beta testing</span> and may contain bugs or inaccuracies.</h6>
            <div className={styles.breakoutButtonsContainer}>
                <ul className={styles_TabOptions.tabWrapper}>
                    {buttons.map((option: any) => {
                        // const active = props.optionsObject[option] ? styles_TabOptions.selected : styles_TabOptions.subtab;
                        let activeOption;

                        option.active ? activeOption = styles_TabOptions.isActive : activeOption = styles_TabOptions.subtab;

                        return (
                            <div
                                key={option.title}
                                className={activeOption}
                                onClick={() => handleClick(option)}
                            >
                                {option.title}
                            </div>
                        );
                    })}
                </ul>
            </div>

            <div className={styles.spaceDiv} />

            {
              renderTables({
                data,
                totalColumns,
                itemsColumns,
                rowClickCallback,
                tablePaginationProps
              })
            }
        </div>
    );
}

export default UserMetricByDay;
